(function(){
  var root = document.querySelector('[data-sp]'); if(!root) return;
  var form = root.querySelector('#sp-form');
  var idSel = root.querySelector('[data-sp-id]');
  var priceEl = root.querySelector('[data-sp-price]');
  var compareEl = root.querySelector('[data-sp-compare]');
  var addBtn = root.querySelector('[data-sp-add]');
  var addText = root.querySelector('[data-sp-addtext]');
  var stickyPrice = root.querySelector('[data-sp-stickyprice]');

  // Thumbnails
  var mainImg = root.querySelector('[data-sp-mainimg]');
  root.querySelectorAll('[data-sp-thumb]').forEach(function(t){
    t.addEventListener('click', function(){
      if(mainImg) mainImg.src = t.getAttribute('data-sp-thumb');
      root.querySelectorAll('[data-sp-thumb]').forEach(function(x){ x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  // Quantity
  var qty = root.querySelector('[data-sp-qty]');
  var minus = root.querySelector('[data-sp-minus]');
  var plus = root.querySelector('[data-sp-plus]');
  if(minus) minus.addEventListener('click', function(){ qty.value = Math.max(1, (parseInt(qty.value,10)||1)-1); });
  if(plus) plus.addEventListener('click', function(){ qty.value = (parseInt(qty.value,10)||1)+1; });

  // Variant option selection
  var selected = {};
  root.querySelectorAll('[data-sp-optindex]').forEach(function(grp){
    var active = grp.querySelector('.sp-pill.is-active');
    var pos = active ? active.getAttribute('data-sp-opt') : grp.querySelectorAll('.sp-pill')[0].getAttribute('data-sp-opt');
    if(active) selected[pos] = active.getAttribute('data-sp-value');
  });

  function syncVariant(){
    if(!idSel) return;
    // Build the desired variant title from selected option values, in order
    var opts = Object.keys(selected).sort(function(a,b){return a-b;}).map(function(k){return selected[k];});
    var want = opts.join(' / ');
    var match = null;
    Array.prototype.forEach.call(idSel.options, function(o){
      if(o.text.trim() === want) match = o;
    });
    if(!match){ // single-option fallback: match by contains
      Array.prototype.forEach.call(idSel.options, function(o){ if(!match && opts.length===1 && o.text.trim()===opts[0]) match=o; });
    }
    if(match){
      idSel.value = match.value;
      var price = match.getAttribute('data-price');
      var avail = match.getAttribute('data-available') === 'true';
      if(price && priceEl){ priceEl.textContent = price; }
      if(price && stickyPrice){ stickyPrice.textContent = price; }
      if(compareEl){
        var cmp = match.getAttribute('data-compare');
        compareEl.style.display = (cmp && cmp !== price) ? '' : 'none';
        if(cmp && cmp !== price) compareEl.textContent = cmp;
      }
      if(addBtn){ addBtn.disabled = !avail; }
      if(addText){ addText.textContent = avail ? 'Add to Cart' : 'Sold Out'; }
    }
  }

  root.querySelectorAll('.sp-pill').forEach(function(pill){
    if(pill.classList.contains('is-soldout')) return;
    pill.addEventListener('click', function(){
      var pos = pill.getAttribute('data-sp-opt');
      selected[pos] = pill.getAttribute('data-sp-value');
      var grp = pill.closest('[data-sp-optindex]');
      grp.querySelectorAll('.sp-pill').forEach(function(x){ x.classList.remove('is-active'); });
      pill.classList.add('is-active');
      var lbl = grp.querySelector('[data-sp-optval]'); if(lbl) lbl.textContent = pill.getAttribute('data-sp-value');
      syncVariant();
    });
  });

  // Sticky add → submit the real form
  var stickyAdd = root.querySelector('[data-sp-stickyadd]');
  if(stickyAdd && form){ stickyAdd.addEventListener('click', function(){ if(addBtn && !addBtn.disabled) form.requestSubmit ? form.requestSubmit(addBtn) : form.submit(); }); }

  // Show sticky bar after scrolling past the buy button
  var sticky = root.querySelector('[data-sp-sticky]');
  if(sticky && addBtn){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ sticky.classList.toggle('is-show', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold:0 });
    io.observe(addBtn);
  }
})();
